import { render, staticRenderFns } from "./vFormPublisher.vue?vue&type=template&id=af4c2016&scoped=true&"
import script from "./vFormPublisher.vue?vue&type=script&lang=js&"
export * from "./vFormPublisher.vue?vue&type=script&lang=js&"
import style0 from "./vFormPublisher.vue?vue&type=style&index=0&id=af4c2016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4c2016",
  null
  
)

export default component.exports